import React from "react";

import { Button, Col } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";

import { CheckCircleSolidGreenIcon } from "@assets/icons";

import styles from "./ResaleSubmitted.module.scss";

interface ResaleSubmittedProps {
  numSubmitted?: number;
  buttonText: string;
  buttonRoute: string;
  messageText: string;
}

export const ResaleSubmitted = ({ numSubmitted, buttonText, buttonRoute, messageText }: ResaleSubmittedProps) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(buttonRoute);
  };

  return (
    <Container fluid className={classNames(styles["container"], "text-center")}>
      <Row>
        <Col className="pb-2">
          {numSubmitted !== undefined ? (
            numSubmitted === 1 ? (
              <h5>{numSubmitted} report submitted</h5>
            ) : (
              <h5>{numSubmitted} reports submitted</h5>
            )
          ) : (
            <h5>Reports submitted</h5>
          )}
        </Col>
      </Row>
      <Row>
        <Col className="pb-5">
          <h3>Uploaded reports submitted</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <ReactSVG className={classNames(styles["img"], "mb-2")} src={CheckCircleSolidGreenIcon} />
        </Col>
      </Row>
      <Row>
        <Col>
          <p className={classNames(styles["message"], "b3", "my-4")}>{messageText}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button className={classNames(styles["button"], "mt-2")} onClick={handleButtonClick}>
            {buttonText}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
